import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { convertLeadTimeToDays } from '@/coreDomainsModule/leadtime';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import {
  ExistsAggregateBusinessParameters,
  ExistsAggregateBusinessSuccessAllOfResult,
} from '@/coreInfrastructureModule/axios/generated/aggregateBusinessManage';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';

/**
 * 集計取引が存在するかどうかを確認する
 */
export class CheckDuplicateAggregateBusinessUseCase {
  private repository: IAggregateBusinessRepository;
  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IAggregateBusinessRepository) {
    this.repository = repository;
  }

  /**
   * 集計取引が存在するかどうかを確認する
   * @param business - 取引情報
   */
  public async execute(business: IBusiness): Promise<INetworkResult<ExistsAggregateBusinessSuccessAllOfResult, Error>> {
    try {
      const parameters: ExistsAggregateBusinessParameters = {
        warehouseNumber: business.warehouseNumber,
        supplierNumber: business.supplierNumber,
        businessNumber: business.businessNumber,
        package: Number(business.package),
        unit: business.unit ?? '',
        leadTime: convertLeadTimeToDays(business.leadTime ?? 0, business.leadTimeUnit ?? ''),
        leadTimeUnit: business.leadTimeUnit ?? '',
        stdInventoryIndicesMin: business.stdInventoryIndices?.標準在庫指数.min ?? 0,
        stdInventoryIndicesMax: business.stdInventoryIndices?.標準在庫指数.max ?? 0,
        stdInventoryIndicesUnit: business.stdInventoryIndices?.標準在庫指数.option.unit ?? '',
        moq: business.MOQ,
      };
      const result = await this.repository.checkDuplicateAggregateBusiness(parameters);

      if (result.status.type === 'error') {
        return {
          status: {
            type: 'error',
            error: Error('取引情報の作成に失敗しました'),
          },
        };
      }

      return {
        status: {
          type: 'success',
          data: result.status.data,
        },
      };
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('取引情報の作成に失敗しました'),
        },
      };
    }
  }
}
